<template>
    <section>
        <div class="role">
            <div class="roleRight">
                <div class="roleRight_Top" style="display: block">
                    <template>
                        <el-select style="margin-bottom: 10px;margin-right: 10px" v-model="search.countryCode" clearable
                            filterable placeholder="IP国家/地区">
                            <el-option v-for="item in countryList" :key="item.code" :label="item.name"
                                :value="item.code"></el-option>
                        </el-select>


                        <!-- 用户选择筛选项 -->
                        <el-select v-model="search.userId" clearable filterable remote reserve-keyword
                            placeholder="选择用户" :remote-method="remoteSearchUser" :loading="userSearchLoading"
                            style="margin-bottom: 10px;margin-right: 10px; width: 200px">
                            <el-option v-for="(item, index) in userList" :key="index"
                                :label="`${item.email} (${item.name || '未设置姓名'})`" :value="item.userInfoId">
                                <div style="display: flex; flex-direction: column;">
                                    <span style="font-weight: bold;">{{ item.email }}</span>
                                    <span style="font-size: 12px; color: #999;">
                                        ID: {{ item.userId }} | 姓名: {{ item.name || '未设置' }}
                                    </span>
                                </div>
                            </el-option>
                        </el-select>

                        <el-select v-model="search.recentChannelAccountId" clearable filterable placeholder="使用渠道"
                            style="margin-bottom: 10px;margin-right: 10px">
                            <el-option v-for="item in channelList" :key="item.channelAccountId"
                                :label="`${item.channelTypeName}-${item.account}`"
                                :value="item.channelAccountId"></el-option>
                        </el-select>
                        <el-select v-model="search.examInfoId" clearable filterable placeholder="测评题"
                            style="margin-bottom: 10px;margin-right: 10px">
                            <el-option v-for="item in examList" :key="item.examInfoId" :label="item.name"
                                :value="item.examInfoId"></el-option>
                        </el-select>

                        <el-button size="medium" type="primary" @click="SearchServiceList">查询</el-button>
                        <el-button size="medium" @click="handleReset">重置</el-button>
                    </template>
                    <!-- <el-button v-if="addShow" size="medium" type="primary" @click="handleAdd"
                  >新增分类</el-button
                  > -->
                </div>
                <div class="roleRight_Container public-table-data">
                    <el-table :data="tableData" size="medium" border style="width: 100%" v-loading="loading">
                        <el-table-column fixed label="序号" type="index" width="80">
                            <template slot-scope="scope">
                                <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="用户地区" prop="country" width="80"></el-table-column>
                        <el-table-column label="用户评测来源" prop="examName" width="100"></el-table-column>
                        <el-table-column label="支付方式" prop="paymentType" width="100"></el-table-column>
                        <el-table-column label="用户邮箱" prop="email" width="100"></el-table-column>
                        <el-table-column label="状态" prop="isDelete" width="100">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.isDelete === 0" type="success">正常</el-tag>
                                <el-tag v-else-if="scope.row.isDelete === 1" type="primary">仅用户可见</el-tag>
                                <el-tag v-else-if="scope.row.isDelete === 2" type="warning">仅后台可见</el-tag>
                                <el-tag v-else type="danger">已删除</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column label="秘密内容" prop="content">
                            <template slot-scope="scope">
                                <div class="text-container">
                                    {{ scope.row.content }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="发布时间" prop="ctime" width="180"></el-table-column>

                        <el-table-column fixed="right" label="操作" width="180">
                            <template slot-scope="scope">

                                <el-button @click="handleDetail(scope.row)" type="text" size="small" v-if="detailShow">
                                    详情
                                </el-button>
                                <el-button @click="handleUserDetail(scope.row)" type="text" size="small"
                                    v-if="detailShow">
                                    查看用户
                                </el-button>
                                <el-button @click="handleAllTreeHole(scope.row)" type="text" size="small" style="color: #00b200"
                                    v-if="detailShow">
                                    所有树洞
                                </el-button>

                                <el-button @click="handleSoftDelete(scope.row)" type="text" size="small"
                                    style="color: #ffa53f" v-if="[0,1].includes(scope.row.isDelete)">
                                    仅用户可见
                                </el-button>
                                <el-button @click="handleSoftDelete(scope.row,3)" type="text" size="small"
                                    style="color: #f56c6c" v-if="[0,1,2].includes(scope.row.isDelete)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>

                <div class="roleRight_pagenation">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="page.pageNo" :page-sizes="[PAGE_SIZE, 15, 20, 25]" :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="page.count">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 详情弹窗 -->
        <DetailDialog ref="detailDialog" title="树洞详情" width="1000px" />
    </section>
</template>
<script>
import {
    PAGE_SIZE,
} from "@/config";
import { formatDate } from "@/utils/filters/filter";
import DetailDialog from "@/components/DetailDialog.vue";
import EditDialog from '@/components/EditDialog.vue';

export default {
    components: {
        DetailDialog,
        EditDialog
    },
    data() {
        return {
            PAGE_SIZE,
            formatDate,

            // 分类状态选项
            CATEGORY_STATUS: [
                { key: 0, name: '上架' },
                { key: 1, name: '下架' }
            ],

            // 分页
            page: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                count: 0
            },
            channelList: [],
            examList: [],
            countryList: [],
            tableData: [], // 分类列表数据
            loading: false,
            search: {},

            // 权限控制
            searchShow: true,
            addShow: true,
            editShow: true,
            deleteShow: true,
            statusShow: true,
            detailShow: true,
            userList: [],
            userSearchLoading: false,
            userSearchTimer: null
        };
    },
    created() {
        this.getChannelList();
        this.getExamList();
        this.getCountryList();
        this.getCategoryList();
        this.getPermissionButtonList();
    },
    beforeDestroy() {
        // 清理定时器
        if (this.userSearchTimer) {
            clearTimeout(this.userSearchTimer);
        }
    },
    methods: {
        // 获取权限按钮列表
        getPermissionButtonList() {
            let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton');
            if (PermissionButtonList) {
                try {
                    let arr = JSON.parse(PermissionButtonList);
                    if (arr && Array.isArray(arr) && arr.length) {
                        arr.forEach(item => {
                            if (item.code === 'question:category:query') {
                                this.searchShow = true;
                            }
                            if (item.code === 'question:category:add') {
                                this.addShow = true;
                            }
                            if (item.code === 'question:category:edit') {
                                this.editShow = true;
                            }
                            if (item.code === 'question:category:delete') {
                                this.deleteShow = true;
                            }
                            if (item.code === 'question:category:status') {
                                this.statusShow = true;
                            }
                            if (item.code === 'question:category:detail') {
                                this.detailShow = true;
                            }
                        });
                    }
                } catch (error) {
                    console.error('权限按钮列表解析失败:', error);
                }
            }
        },

        // 搜索
        SearchServiceList() {
            this.page.pageNo = 1;
            this.getCategoryList();
        },

        // 获取分类列表
        async getCategoryList() {
            this.loading = true;
            try {
                const { data: res } = await this.$post(
                    `/treehole/list`,
                    {
                        ...this.search,
                        pageNo: this.page.pageNo,   // 页码
                        pageSize: this.page.pageSize // 每页条数
                    },
                    {
                        headers: {
                            isLoading: true,
                        },
                    }
                );

                if (res && Array.isArray(res.data)) {
                    this.tableData = res.data;
                    if (res.page) {
                        this.page.count = res.page.count || 0;
                    } else {
                        this.page.count = 0;
                    }
                }
            } catch (error) {
                console.error('获取分类列表失败:', error);
                this.$message.error('获取分类列表失败');
            } finally {
                this.loading = false;
            }
        },
        async getChannelList() {
            const { data: orgData } = await this.$get(`/channel/account/list?paging=false`);
            this.channelList = orgData.data;
        },
        async getExamList() {
            const { data } = await this.$get(`/exam/list?status=1&pageNo=1&pageSize=1000`);
            this.examList = data.data;
        },
        async getCountryList() {
            const { data: res } = await this.$post(
                `/country/page`, { pageNo: 1, pageSize: 1000 },
            );
            this.countryList = res.data;
        },
        // 查看详情
        async handleDetail(row) {
            // 检查ref是否存在
            if (!this.$refs.detailDialog) {
                console.error('DetailDialog组件未找到');
                this.$message.error('详情组件加载失败，请刷新页面重试');
                return;
            }

            // 定义分类详情列配置
            const detailColumns = [
                { label: '用户评测来源', prop: 'examName', type: 'text' },
                { label: '支付方式', prop: 'paymentType', type: 'text' },
                { label: '用户邮箱', prop: 'email', type: 'text' },
                { label: '用户地区', prop: 'country', type: 'text' },
                { label: '发布时间', prop: 'publishTime', type: 'text' }
                // { label: '秘密内容', prop: 'content', type: 'text'}, // 移除秘密内容
            ];

            this.$refs.detailDialog.open(row, detailColumns);
        },

        // 物理删除
        async handleDelete(row) {
            try {
                await this.$confirm('确定要物理删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });

                // 调用删除接口
                await this.$get(`/treehole/delete/${row.id}`);
                this.$message.success('删除成功');
                this.getCategoryList();
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除失败:', error);
                    this.$message.error('删除失败');
                }
            }
        },

        // 物理删除
        async handleSoftDelete(row,isDelete=2) {
            try {
                await this.$confirm('确定要删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });

                // 调用删除接口
                await this.$post(`treehole/updateStatus`, {
                    ...row,
                    isDelete: isDelete
                });
                this.$message.success('删除成功');
                this.getCategoryList();
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除失败:', error);
                    this.$message.error('删除失败');
                }
            }
        },

        handleUserDetail(row) {
            this.$router.push({
                name: "USER_DETAIL_PAGE",
                query: {
                    id: 3,
                    title: "用户列表",
                    key: "userId",
                    value: JSON.stringify(row.email),
                    path: "/user/list/detail",
                },
            });
        },
        async handleAllTreeHole(row) {
            this.loading = true;
            // 1. 远程搜索用户（用邮箱），
            await this.remoteSearchUser(row.email);
            this.search.userId = row.userId;
            await this.SearchServiceList();
            this.loading = false;
            const userName = row.name || row.email || row.userId;
            this.$message.success(`已查到${userName}用户的所有树洞`);
        },

        // 分页
        handleSizeChange(val) {
            this.page.pageSize = val;
            this.getCategoryList();
        },

        handleCurrentChange(val) {
            this.page.pageNo = val;
            this.getCategoryList();
        },

        // 重置搜索条件
        handleReset() {
            this.search = {};
            this.page.pageNo = 1;
            this.getCategoryList();
        },

        getBasicColumns() {
            return [
                { label: 'ID', prop: 'id', type: 'text', addHide: true },
                { label: '分类名称', prop: 'name', type: 'text', required: true },
                { label: '分类图标', prop: 'icon', type: 'image' },
                { label: '分类描述', prop: 'description', type: 'textarea' },
                { label: '排序', prop: 'sortOrder', type: 'number' },
                { label: '是否下架', prop: 'isOffline', type: 'switch' },
                { label: '是否删除', prop: 'isDelete', type: 'switch', addHide: true },
                { label: '创建时间', prop: 'ctime', type: 'date', hide: true, addHide: true, editHide: true },
                { label: '更新时间', prop: 'utime', type: 'date', hide: true, addHide: true, editHide: true }
            ];
        },
        getTestList() {
            this.$get('/treehole/list', {
                pageNo: 1,
                pageSize: 10
            }).then(res => {
                console.log(res);
            });
        },
        // 用户模糊搜索（带防抖）
        remoteSearchUser(query) {
            // 清除之前的定时器
            if (this.userSearchTimer) {
                clearTimeout(this.userSearchTimer);
            }

            // 返回 Promise 以支持 async/await
            return new Promise((resolve, reject) => {
                // 设置新的定时器，300ms后执行搜索
                this.userSearchTimer = setTimeout(() => {
                    if (query !== '') {
                        this.userSearchLoading = true;
                        this.$get(
                            `/user/list/query`,
                            {
                                params: {
                                    email: query,
                                    pageNo: 1,
                                    pageSize: 20
                                }
                            }
                        ).then(res => {
                            this.userList = res.data.data.records || [];
                            this.userSearchLoading = false;
                            resolve();
                        }).catch(() => {
                            this.userSearchLoading = false;
                            reject();
                        });
                    } else {
                        this.userList = [];
                        resolve();
                    }
                }, 300);
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.role {
    display: flex;
    gap: 20px;
    color: #666;
    /** 公共的黑色 --暂定 */
    font-size: 14px;

    &Right {
        flex: 1;
        display: flex;
        overflow-x: hidden;
        flex-direction: column;

        &_Top {
            display: flex;
            gap: 15px;

            .el-input {
                width: auto;
            }

            .timeblock {
                display: flex;
                box-sizing: border-box;
                background: #fff;
                border: 1px solid #dcdfe6;
                border-radius: 5px;

                .cla ::v-deep .el-input--suffix .el-input__inner {
                    padding-right: 0;
                }

                ::v-deep .el-input__inner {
                    border: none !important;
                    height: 38px;
                }
            }
        }

        &_Container {
            margin-top: 20px;
        }

        &_pagenation {
            margin: 40px auto;
        }

        ::v-deep .el-table th,
        ::v-deep .el-table td {
            text-align: center !important;
        }
    }
}

.text-container {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>